import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoadingService } from '../../services/loading.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';
import { EventSubscription, EventSubscriptionInput } from '../../entities/events/event';
import { EventSubscriptionService } from '../../services/eventSubscription/eventSubscriptionService';
import { EditSelectable } from '../edit-select-form-control/edit-select-form-control.component';
import { CustomAttributeSection } from '../../entities/customAttributes/customAttributes';
import { CustomAttributesService } from '../../services/customAttributes/customAttributesService';
import { RolesService } from '../../services/roles/roles.service';

@Component({
  selector: 'app-custom-attribute-section-dialog',
  templateUrl: './custom-attribute-section-dialog.component.html',
  styleUrls: ['./custom-attribute-section-dialog.component.scss']
})
export class CustomAttributeSectionDialogComponent
  implements EditDialogInstance {

  customAttributeSectionForm: FormGroup;
  customAttributeSection: CustomAttributeSection;
  nextIndex: number;
  entityType: any;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public loadingService: LoadingService,
    public customAttributeService: CustomAttributesService,
    private rolesService: RolesService
  ) {

    if (this.config.data) {
      this.customAttributeSection = this.config.data?.customAttributeSection;
      this.nextIndex = this.config.data?.nextIndex;
      this.entityType = this.config.data?.entityType;
    }

    this.customAttributeSectionForm = new FormGroup({});
    this.customAttributeSectionForm.addControl('id', new FormControl());
    // add form controls
    this.customAttributeSectionForm.addControl('externalId', new FormControl());
    this.customAttributeSectionForm.addControl('label', new FormControl(undefined, [Validators.required]));
    let indexFormControl = new FormControl(this.nextIndex, Validators.required);
    this.customAttributeSectionForm.addControl('index', indexFormControl);
    if(!this.isAdmin()){ // admin can directly set the index
      indexFormControl.disable(); // disable the index field, as it is automatically set
    }

    let entityFormControl = new FormControl(this.entityType?.id, Validators.required);
    this.customAttributeSectionForm.addControl('entity', entityFormControl);
    entityFormControl.disable(); // disable the entity field, as it is automatically

    if (this.customAttributeSection) {
      this.customAttributeSectionForm.patchValue(this.customAttributeSection);
    }

  }


  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    this.loadingService.setLoading(true);
    let customAttributeSectionInput = new CustomAttributeSection(this.customAttributeSectionForm.getRawValue());
    if (this.customAttributeSection) {
      this.customAttributeService.update(customAttributeSectionInput, (result: any) => {
        this.loadingService.setLoading(false);
        this.ref.close(result?.data?.updateCustomAttributeSection?.id);
      });
    } else {
      this.customAttributeService.create(customAttributeSectionInput, (result: any) => {
        this.loadingService.setLoading(false);
        this.ref.close(result?.data?.createCustomAttributeSection?.id);
      });
    }
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.customAttributeSectionForm;
  }

  isAdmin(): boolean {
    return this.rolesService.hasRole('framework_tenants_manage');
  }

}
